import type { UseFormReturn } from 'react-hook-form';
import {
  NotificationPriority,
  NotificationType,
  type CreateNotificationFormFields,
} from 'hooks/useNotification';

const MESSAGE_FIELD_BY_CHANNEL: Partial<
  Record<
    NotificationType,
    'emailMessage' | 'smsMessage' | 'appMessage' | 'teamsMessage'
  >
> = {
  [NotificationType.EMAIL]: 'emailMessage',
  [NotificationType.SMS]: 'smsMessage',
  [NotificationType.IN_APP]: 'appMessage',
  [NotificationType.TEAMS]: 'teamsMessage',
};

export type EventNotificationFormValues = Pick<
  CreateNotificationFormFields,
  | 'notificationTypes'
  | 'emailSubject'
  | 'emailMessage'
  | 'smsMessage'
  | 'teamsMessage'
  | 'appMessage'
  | 'acknowledgementRequired'
  | 'userIds'
  | 'priority'
>;

export const EVENT_NOTIFICATION_DEFAULTS: EventNotificationFormValues = {
  notificationTypes: [NotificationType.IN_APP],
  emailSubject: '',
  emailMessage: '',
  smsMessage: '',
  teamsMessage: '',
  appMessage: '',
  acknowledgementRequired: false,
  userIds: [],
  priority: NotificationPriority.INFO,
};

export const validateEventNotification = ({
  getValues,
  setError,
  clearErrors,
}: UseFormReturn<EventNotificationFormValues>) => {
  clearErrors();
  const values = getValues();
  let isValid = true;

  if (values.notificationTypes.length === 0) {
    setError('notificationTypes', { message: 'Select at least one channel' });
    isValid = false;
  }
  if (
    values.notificationTypes.includes(NotificationType.EMAIL) &&
    !values.emailSubject?.trim()
  ) {
    setError('emailSubject', { message: 'Email subject is required' });
    isValid = false;
  }
  values.notificationTypes.forEach((channel) => {
    const field = MESSAGE_FIELD_BY_CHANNEL[channel];
    if (field && !values[field]?.trim()) {
      setError(field, { message: `A ${channel} message is required` });
      isValid = false;
    }
  });
  if (values.userIds.length === 0) {
    setError('userIds', { message: 'Please select at least one individual' });
    isValid = false;
  }
  if (!values.priority) {
    setError('priority', { message: 'Please select a severity' });
    isValid = false;
  }
  return isValid;
};
